import type {
    ChatSuggestAction,
    ChatSuggestion,
} from "../../Models/ChatSuggestion";

const submitSuggestionContentAction: ChatSuggestAction = (store, suggestion) =>
    store.streamingSubmitInput({
        manualInput: suggestion.content,
        suggestion: true,
    });

export const preCannedSuggestions: ChatSuggestion[] = [
    "What are the top 5 drivers in conversations with Eddies?",
    "What was the average call duration in the past month?",
    "What are the main drivers in conversations with negative ending sentiment?",
    "What drivers are causing an increase in call duration?",
    "What new drivers are creating eddies?",
    "How many calls started with a positive sentiment but included an Eddy?",
    "Who has been calling this month?",
    "Who experiences the most Eddies?",
    "How much preventable talk time was there last week?",
    "What is an Eddy?",
    "How does Authenticx reduce risk?",
    "Why is analyzing call data important?",
].map((content) => ({
    content,
    action: submitSuggestionContentAction,
    doNotSendToLlm: true,
}));

function randomIndex(arr: unknown[]): number {
    return Math.floor(Math.random() * arr.length);
}

export function selectTwoRandomSuggestions(
    options: ChatSuggestion[],
): ChatSuggestion[] {
    const firstIdx = randomIndex(options);
    let secondIdx: number;
    do {
        secondIdx = randomIndex(options);
    } while (firstIdx === secondIdx);

    return [options[firstIdx], options[secondIdx]];
}
